import { render, staticRenderFns } from "./attachment.vue?vue&type=template&id=4fa983e2&scoped=true&"
import script from "./attachment.vue?vue&type=script&lang=ts&"
export * from "./attachment.vue?vue&type=script&lang=ts&"
import style0 from "./attachment.vue?vue&type=style&index=0&id=4fa983e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa983e2",
  null
  
)

export default component.exports